import React from "react";
import { Form } from "semantic-ui-react";

import postData from "./data/messages.json";
import postTypeOptions from "./data/postTypes";

import PostImages from "./PostImages";

export default function PostOptions({
  postType,
  onPostTypeChange,
  postMessage,
  onPostMessageChange,
  postImg,
  setPostImg,
}) {
  return (
    <div className="post-options">
      <Form>
        <Form.Select
          options={postTypeOptions}
          placeholder="Select one..."
          label="Post Type"
          value={postType}
          onChange={(e, d) => onPostTypeChange(d.value)}
        />
        <Form.Select
          placeholder="Select one..."
          value={postMessage}
          onChange={(e, d) => onPostMessageChange(d.value)}
          options={postData.messages.map((p, i) => ({
            text: p.text,
            key: p.id,
            value: p.id,
          }))}
          label="Post Message"
        />
        <PostImages img={postImg} onChange={setPostImg} />
      </Form>
    </div>
  );
}

PostOptions.defaultProps = {
  postMessage: null,
  postType: null,
};
